export interface PartnerLogColDef {
  flex: number;
  minWidth: number;
  cellDataType: string;
  field: string;
  headerName: string;
  sortable?: boolean;
  lockPosition?: string;
  checkboxSelection?: boolean;
  filter?: string;
  valueGetter?: (params: any) => any;
  filterPath?: string; // Used for server-side filtering
  filterParams?: {
    maxNumConditions?: number;
    [key: string]: any;
  };
  cellRenderer?: string | any;
  autoHeight?: boolean;
  wrapText?: boolean;
}

export const PartnerLogColDef: PartnerLogColDef[] = [
  {
    flex: 1,
    minWidth: 20,
    cellDataType: 'string',
    field: 'partner',
    headerName: 'Partner',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.partner || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'partner'
  },
  {
    flex: 1,
    minWidth: 20,
    cellDataType: 'string',
    field: 'alid',
    headerName: 'ALID',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.alid || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'alid'
  },
  {
    flex: 1,
    minWidth: 20,
    cellDataType: 'string',
    field: 'territory',
    headerName: 'Territory',
    sortable: true,
    valueGetter: (params) => {
      return params.data?.territory || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'territory'
  },
  {
    flex: 1,
    minWidth: 20,
    cellDataType: 'integer',
    field: 'response_code',
    headerName: 'Response Code',
    sortable: false,
    valueGetter: (params) => {
      return params.data?.response_code;
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'response_code'
  },
  {
    flex: 3,
    minWidth: 300,
    cellDataType: 'string',
    field: 'response_message',
    headerName: 'Response Message',
    sortable: true,
    cellRenderer: 'ResponseMessageCellRenderer',
    wrapText: true,
    valueGetter: (params) => {
      return params.data?.response_message || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'response_message'
  },
  {
    flex: 1,
    minWidth: 20,
    cellDataType: 'date',
    field: 'created_at',
    headerName: 'Date',
    sortable: false,
    valueGetter: (params) => {
      return params.data?.created_at || '';
    },
    filterParams: {
      filterOptions: ['contains', 'equals', 'notEqual'], // limit the filter types
    },
    filterPath: 'created_at'
  },
  
];